/**
 * @flow
 * @relayHash 36cf57d63dec8ccda4a68e892fd025bd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type BrokerActivityGroupAssignToMutationVariables = {|
  brokerActivityGroupId: string,
  brokerActivityId: string,
|};
export type BrokerActivityGroupAssignToMutationResponse = {|
  +assignToBrokerActivityGroup: ?{|
    +brokerActivity: ?{|
      +id: string,
      +group: ?{|
        +id: string,
        +description: ?string,
        +brokeractivitySet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +ibcorporateaction: ?{|
                +id: string,
                +ignored: boolean,
                +processedAt: ?any,
                +processedBy: ?{|
                  +username: string,
                  +fullName: ?string,
                |},
                +group: ?{|
                  +id: string,
                  +description: ?string,
                |},
                +transactionId: any,
                +ibConId: number,
                +currency: ?Currency,
                +description: string,
                +isin: ?string,
                +symbol: string,
                +transactionDatetime: any,
                +reportDate: any,
                +quantity: number,
                +proceeds: number,
                +type: string,
                +contract: ?{|
                  +id: string,
                  +symbol: string,
                  +currency: Currency,
                  +ibConId: any,
                |},
                +notes: ?{|
                  +id: string
                |},
                +brokeractivityPtr: {|
                  +id: string,
                  +group: ?{|
                    +id: string,
                    +description: ?string,
                  |},
                  +responsiblecontract: ?{|
                    +contract: {|
                      +symbol: string,
                      +id: string,
                      +ibConId: any,
                      +name: ?string,
                      +currency: Currency,
                      +exchange: {|
                        +name: string,
                        +symbol: string,
                      |},
                    |}
                  |},
                  +brokeractivitytransactionSet: {|
                    +edges: $ReadOnlyArray<?{|
                      +node: ?{|
                        +id: string,
                        +account: {|
                          +name: ?string,
                          +id: string,
                        |},
                        +brokeractivitytransactioncontractdeltaSet: {|
                          +edges: $ReadOnlyArray<?{|
                            +node: ?{|
                              +portfolio: {|
                                +id: string
                              |},
                              +contract: {|
                                +id: string,
                                +symbol: string,
                              |},
                              +quantity: number,
                            |}
                          |}>
                        |},
                        +brokeractivitytransactioncashdeltaSet: {|
                          +edges: $ReadOnlyArray<?{|
                            +node: ?{|
                              +currency: Currency,
                              +quantity: number,
                            |}
                          |}>
                        |},
                      |}
                    |}>
                  |},
                |},
              |}
            |}
          |}>
        |},
      |},
    |}
  |}
|};
export type BrokerActivityGroupAssignToMutation = {|
  variables: BrokerActivityGroupAssignToMutationVariables,
  response: BrokerActivityGroupAssignToMutationResponse,
|};
*/


/*
mutation BrokerActivityGroupAssignToMutation(
  $brokerActivityGroupId: ID!
  $brokerActivityId: ID!
) {
  assignToBrokerActivityGroup(brokerActivityGroupId: $brokerActivityGroupId, brokerActivityId: $brokerActivityId) {
    brokerActivity {
      id
      group {
        id
        description
        brokeractivitySet {
          edges {
            node {
              ibcorporateaction {
                id
                ignored
                processedAt
                processedBy {
                  username
                  fullName
                  id
                }
                group {
                  id
                  description
                }
                transactionId
                ibConId
                currency
                description
                isin
                symbol
                transactionDatetime
                reportDate
                quantity
                proceeds
                type
                contract {
                  id
                  symbol
                  currency
                  ibConId
                }
                notes {
                  id
                }
                brokeractivityPtr {
                  id
                  group {
                    id
                    description
                  }
                  responsiblecontract {
                    contract {
                      symbol
                      id
                      ibConId
                      name
                      currency
                      exchange {
                        name
                        symbol
                        id
                      }
                    }
                    id
                  }
                  brokeractivitytransactionSet {
                    edges {
                      node {
                        id
                        account {
                          name
                          id
                        }
                        brokeractivitytransactioncontractdeltaSet {
                          edges {
                            node {
                              portfolio {
                                id
                              }
                              contract {
                                id
                                symbol
                              }
                              quantity
                              id
                            }
                          }
                        }
                        brokeractivitytransactioncashdeltaSet {
                          edges {
                            node {
                              currency
                              quantity
                              id
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "brokerActivityGroupId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "brokerActivityId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brokerActivityGroupId",
    "variableName": "brokerActivityGroupId"
  },
  {
    "kind": "Variable",
    "name": "brokerActivityId",
    "variableName": "brokerActivityId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ignored",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "processedAt",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "group",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityGroupNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transactionId",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isin",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transactionDatetime",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "reportDate",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceeds",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    (v11/*: any*/),
    (v10/*: any*/)
  ]
},
v20 = [
  (v2/*: any*/)
],
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "notes",
  "storageKey": null,
  "args": null,
  "concreteType": "NotesNode",
  "plural": false,
  "selections": (v20/*: any*/)
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "account",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountNode",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v2/*: any*/)
  ]
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": (v20/*: any*/)
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BrokerActivityGroupAssignToMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "assignToBrokerActivityGroup",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignToBrokerActivityGroup",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "group",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityGroupNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivitySet",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNodeConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNodeEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityNode",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ibcorporateaction",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "IBCorporateActionNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "processedBy",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  },
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v3/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "brokeractivityPtr",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "responsiblecontract",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ResponsibleContractNode",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "contract",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ContractNode",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v2/*: any*/),
                                              (v10/*: any*/),
                                              (v22/*: any*/),
                                              (v11/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "exchange",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ExchangeNode",
                                                "plural": false,
                                                "selections": [
                                                  (v22/*: any*/),
                                                  (v13/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactionSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionNode",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v23/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "brokeractivitytransactioncontractdeltaSet",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                                            "plural": false,
                                                            "selections": [
                                                              (v24/*: any*/),
                                                              (v25/*: any*/),
                                                              (v16/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "brokeractivitytransactioncashdeltaSet",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v16/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BrokerActivityGroupAssignToMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "assignToBrokerActivityGroup",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignToBrokerActivityGroup",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "group",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityGroupNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivitySet",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNodeConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNodeEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityNode",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ibcorporateaction",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "IBCorporateActionNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "processedBy",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  },
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v3/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "brokeractivityPtr",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "responsiblecontract",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ResponsibleContractNode",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "contract",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ContractNode",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v2/*: any*/),
                                              (v10/*: any*/),
                                              (v22/*: any*/),
                                              (v11/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "exchange",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ExchangeNode",
                                                "plural": false,
                                                "selections": [
                                                  (v22/*: any*/),
                                                  (v13/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          (v2/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactionSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionNode",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v23/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "brokeractivitytransactioncontractdeltaSet",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                                            "plural": false,
                                                            "selections": [
                                                              (v24/*: any*/),
                                                              (v25/*: any*/),
                                                              (v16/*: any*/),
                                                              (v2/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "brokeractivitytransactioncashdeltaSet",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v16/*: any*/),
                                                              (v2/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "BrokerActivityGroupAssignToMutation",
    "id": null,
    "text": "mutation BrokerActivityGroupAssignToMutation(\n  $brokerActivityGroupId: ID!\n  $brokerActivityId: ID!\n) {\n  assignToBrokerActivityGroup(brokerActivityGroupId: $brokerActivityGroupId, brokerActivityId: $brokerActivityId) {\n    brokerActivity {\n      id\n      group {\n        id\n        description\n        brokeractivitySet {\n          edges {\n            node {\n              ibcorporateaction {\n                id\n                ignored\n                processedAt\n                processedBy {\n                  username\n                  fullName\n                  id\n                }\n                group {\n                  id\n                  description\n                }\n                transactionId\n                ibConId\n                currency\n                description\n                isin\n                symbol\n                transactionDatetime\n                reportDate\n                quantity\n                proceeds\n                type\n                contract {\n                  id\n                  symbol\n                  currency\n                  ibConId\n                }\n                notes {\n                  id\n                }\n                brokeractivityPtr {\n                  id\n                  group {\n                    id\n                    description\n                  }\n                  responsiblecontract {\n                    contract {\n                      symbol\n                      id\n                      ibConId\n                      name\n                      currency\n                      exchange {\n                        name\n                        symbol\n                        id\n                      }\n                    }\n                    id\n                  }\n                  brokeractivitytransactionSet {\n                    edges {\n                      node {\n                        id\n                        account {\n                          name\n                          id\n                        }\n                        brokeractivitytransactioncontractdeltaSet {\n                          edges {\n                            node {\n                              portfolio {\n                                id\n                              }\n                              contract {\n                                id\n                                symbol\n                              }\n                              quantity\n                              id\n                            }\n                          }\n                        }\n                        brokeractivitytransactioncashdeltaSet {\n                          edges {\n                            node {\n                              currency\n                              quantity\n                              id\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '572cd783650aedcab546c8e4f9953933';
module.exports = node;
